/**
 * Add connection component save, update and clone connection to database as well upload content images and hero image to s3 bucket.
 */

import CKEditor from "ckeditor4-react";
import cx from "classnames";
import * as _ from "lodash";
import React from "react";
import { Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { deviceDetect } from "react-device-detect";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { BackStrip, Header } from "../../../common/layout";
import { utilPostService, utilService } from "../../../common/utils";
import { config } from "../../../config/config";
import * as pagesActions from "../../../store/admin";

class AddPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.subscriptions = [];
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onFileUploadReq = this.onFileUploadReq.bind(this);
    this.onFileUploadRes = this.onFileUploadRes.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.state = {
      isLoading: false,
      isSaving: false,
      pageData: {
        navigation: false,
        landing_page: false,
        is_deleted: false,
        file_view_type: "list",
      },
      places: [],
      placeGroups: [],
      errors: {},
    };
    this.fieldNames = {
      place: { name: "placeUid", errorKey: "place" },
      pageType: { name: "pagetypeUid", errorKey: "pagetype" },
      title: { name: "title", errorKey: "title" },
      landingPage: { name: "landing_page" },
      isDeleted: { name: "is_deleted" },
      navigation: { name: "navigation" },
      contentHtml: { name: "content_html", errorKey: "content_html" },
      googleFolderID: {
        name: "google_drive_url",
        type: "file_view_type",
        errorKey: "googleFolder",
      },
      description: { name: "description", errorKey: "description" },
    };
    this.fileRepoPageTypeName = "Documents";
    this.selectedPageType = {};
    this.CKE = null;
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();

    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "add-page",
      title: "Add Page",
      browserName: browserName,
      osName: osName,
      pageType: "Add Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    const id = this.props.match.params.id;
    if (id) {
      // fetch post based on postUid
      this.props.fetchPage({
        id: this.props.match.params.id,
        token: this.props.token,
      });
    }
    // fetch places
    this.props.fetchPlaces({
      token: this.props.token,
      params: "",
    });

    // get page types
    this.props.fetchPageTypes({
      token: this.props.token,
      params: "",
    });
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs in state and props
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSaving) {
      if (prevProps.pageActionLoading && !this.props.pageActionLoading) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            isSaving: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Page saved successfully."
            );
            this.props.history.push("/admin");
          }
        );
      }
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.page) {
      if (nextProps.page !== this.props.page) {
        let pageJson = nextProps.page;
        this.setState({
          ...this.state,
          pageData: pageJson,
        });
      }
    }
    if (nextProps.places) {
      if (nextProps.places.length > 0) {
        this.setState(
          {
            places: nextProps.places,
          },
          function () {
            this.getPlaceGroups(this.state.pageData.placeUid);
          }
        );
      }
    }
  }
  componentWillUnmount() {
    if (this.CKE) {
      for (let key in this.CKE.instances) {
        this.CKE.instances[key].destroy();
      }
    }
  }

  /**
   * Handle input change event
   * @param {*} e
   */
  handleInputChange(e) {
    const { name, value } = e.target;
    let fields = this.state.pageData;

    if (name === this.fieldNames.navigation.name) {
      fields[name] = e.target.checked;
    } else if (name === this.fieldNames.landingPage.name) {
      fields[name] = e.target.checked;
    } else if (name === this.fieldNames.isDeleted.name) {
      fields[name] = e.target.checked;
    } else {
      if (name === this.fieldNames.title.name) {
        let slug = value.trim();
        slug = slug.toLowerCase();
        slug = slug.split(" ");
        slug = slug.filter((e) => e !== "");
        slug = slug.join("-");
        fields["slug"] = slug;
      }
      fields[name] = value;
    }
    this.setState({
      fields,
    });
    if (name === this.fieldNames.place.name) {
      this.getPlaceGroups(value);
    }
  }

  /**
   * Get groups of selected place in drop down
   * @param {*} placeId
   */
  getPlaceGroups(placeId) {
    if (placeId) {
      // find place obj from places list
      let placeObj = _.find(this.state.places, function (o) {
        return o.placeUid === placeId;
      });
      let groups = [];
      if (
        placeObj["group_list"] &&
        placeObj["group_list"]["groups"].length > 0
      ) {
        groups = placeObj["group_list"]["groups"];
      }
      // update state
      this.setState({
        ...this.state,
        pageData: {
          ...this.state.pageData,
          editors: placeObj.editors,
          place_place: placeObj.place,
          place_slug: placeObj.slug,
        },
        placeGroups: groups,
      });
    } else {
      this.setState({
        placeGroups: [],
      });
    }
  }

  /**
   * Set content of editor
   * @param {*} e
   */

  onEditorChange(e) {
    let fields = this.state.pageData;
    // let editor_text = e.editor.document.getBody().getText();
    fields["content_html"] = e.editor.getData();
    // const id = this.props.match.params.id;
    // if (id) {
    //   if (this.state.init_excertp) {
    //     fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    //   }
    // } else {
    //   fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    // }
    // if (!this.state.excerpt_change) {
    //   fields["excerpt"] = editor_text ? editor_text.slice(0, 150) : "";
    // }
    this.setState({
      fields,
    });
  }

  /**
   * Summary. Function used to send server request to upload image.
   *
   * @param {*} e  ckeditor upload event
   */
  onFileUploadReq(e) {
    let xhr = e.data.fileLoader.xhr;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Authorization", "Bearer " + this.props.token);
    xhr.send(
      JSON.stringify({
        base64ImageUrl: e.data.fileLoader.data.split(",")[1],
      })
    );
    e.stop();
    e.cancel();
  }

  /**
   * Summary. Function used to get response of upload editor image from server.
   * @param {*} e upload response event
   */
  onFileUploadRes(e) {
    e.stop();

    let data = e.data;
    let xhr = data.fileLoader.xhr;

    let response = xhr.responseText.split("|");

    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      e.cancel();
    } else {
      let parse_response = JSON.parse(response[0].toString());
      data.url = parse_response["responceObject"]["records"]["url"];
    }
  }

  /**
   * Validate form field before sumbmitting
   */
  validateForm() {
    let fields = this.state.pageData;
    let errors = {};
    let formIsValid = true;

    if (!fields[this.fieldNames.place.name]) {
      formIsValid = false;
      errors[this.fieldNames.place.errorKey] = "*Please select place.";
    }
    if (!fields[this.fieldNames.pageType.name]) {
      formIsValid = false;
      errors[this.fieldNames.pageType.errorKey] = "*Please select page type.";
    }
    if (!fields[this.fieldNames.title.name]) {
      formIsValid = false;
      errors[this.fieldNames.title.errorKey] = "*Please enter page title.";
    }
    if (
      !fields[this.fieldNames.contentHtml.name] &&
      this.selectedPageType.pageType === "Static Page"
    ) {
      formIsValid = false;
      errors[this.fieldNames.contentHtml.errorKey] = "*Please enter content.";
    }
    if (
      !fields[this.fieldNames.googleFolderID.name] &&
      this.selectedPageType.pageType === this.fileRepoPageTypeName
    ) {
      formIsValid = false;
      errors[this.fieldNames.googleFolderID.errorKey] =
        "*Please enter Google Drive folder ID.";
    }
    if (!fields[this.fieldNames.description.name]) {
      formIsValid = false;
      errors[this.fieldNames.description.errorKey] =
        "*Please enter description.";
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateForm()) {
      let fields = this.state.pageData;
      if (fields.pagetypeUid) {
        let pageTypeObj = _.find(this.props.pageTypes, function (o) {
          return o.pagetypeUid === fields.pagetypeUid;
        });
        fields["pagetype_pagetype"] = pageTypeObj.pageType;
      }
      let content_string = fields[this.fieldNames.contentHtml.name];
      let res_list = utilPostService.getAttrFromString(
        fields[this.fieldNames.contentHtml.name],
        "iframe",
        "src",
        ""
      );
      res_list.map(async function (single) {
        let url = single.key;
        if (url && url.includes("https://drive.google.com/")) {
          let driveId = utilService.getGoogleDriveUrlId(url);
          let fileType = "list";
          if (url.includes("#grid")) {
            fileType = "grid";
          }
          content_string = content_string.replace(
            url,
            "https://drive.google.com/a/plc.nsw.edu.au/embeddedfolderview?id=" +
              driveId +
              "#" +
              fileType
          );
        }
      });
      fields["content_html"] = content_string;

      // Replace content_html's img tage src attribute to save uuid of editor images.

      let res = utilPostService.getAttrFromString(
        fields[this.fieldNames.contentHtml.name],
        "img",
        "src",
        "style"
      );
      res.map(async function (single) {
        let url = single.key;
        url = url.replace(config.url.media_bucket_url, "");
        url = url.split("?");
        let key = url[0].split("/");
        content_string = content_string.replace(single.key, key[1]);
      });
      let regex = new RegExp('<a.*?href="(.*?)"(.*?)</a>', "gi");

      let result = [];

      while ((result = regex.exec(content_string))) {
        if (result[0]) {
          let content_first_part = content_string.substr(0, result["index"]);

          let str_second_part = content_string.substring(
            result["index"],
            regex.lastIndex
          );

          let content_second_part_list = str_second_part.split(" ");

          if (!result[0].includes('style="')) {
            content_second_part_list[0] =
              content_second_part_list[0] +
              ' style="color: #C41425;text-decoration: none;"';
          }

          str_second_part = content_second_part_list.join(" ");

          let content_third_part = content_string.substr(regex.lastIndex);

          content_string =
            content_first_part + str_second_part + content_third_part;
        }
      }
      fields["content_html"] = content_string;
      if (fields["google_drive_url"]) {
        let drive_url = fields["google_drive_url"];
        let driveId = utilService.getGoogleDriveUrlId(drive_url);
        drive_url =
          "https://drive.google.com/a/plc.nsw.edu.au/embeddedfolderview?id=" +
          driveId +
          "#" +
          fields["file_view_type"];
        fields["google_drive_url"] = drive_url;
      }
      fields["updated_at"] = new Date();
      if (!this.state.pageData.pageUid) {
        fields["created_at"] = new Date();
      } else {
        if (!fields["created_at"]) {
          fields["created_at"] = new Date();
        }
      }
      fields["users_userid"] = this.props.user.userUid;
      fields["users_username"] = this.props.user.username;
      fields["users_firstname"] = this.props.user.firstname;
      fields["users_lastname"] = this.props.user.surname;

      this.setState({
        fields,
        isSaving: true,
        isLoading: true,
      });
      if (this.state.pageData.pageUid) {
        this.props.updatePage({
          token: this.props.token,
          data: { pageData: this.state.pageData },
        });
      } else {
        this.props.savePage({
          token: this.props.token,
          data: { pageData: this.state.pageData },
        });
      }
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    const { pageTypes, places } = this.props;
    this.selectedPageType =
      pageTypes.find((page) => {
        const pageDataState = this.state.pageData;
        if (pageDataState.pagetypeUid) {
          return page.pagetypeUid === pageDataState.pagetypeUid;
        }
      }) || {};
    return (
      <div>
        <BackStrip nav="/admin" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Add Page" />
            <main className="admin-home">
              <div className="container" style={{ maxWidth: "95%" }}>
                <form ref={(el) => (this.myFormRef = el)} name="addPost">
                  <div className="row justify-content-end brd-btm">
                    <ul
                      className="nav nav-pills d-flex justify-content-center"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <NavLink className="nav-link active" to="/admin">
                          Admin Home
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Places
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                    <h1>CREATE PAGE</h1>
                  </div>
                  <Row>
                    <Col md={4} className="bg-offlight reps-m-2">
                      <div className="radioslide" />
                      <div>
                        <h2 className="selected-group-title">
                          Selected Groups
                        </h2>
                        <div className="selected-group">
                          {this.state.placeGroups.map(
                            (item, index) =>
                              item.groupname +
                              (this.state.placeGroups.length - 1 !== index
                                ? ","
                                : "")
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={8}>
                      <div className="filters">
                        <Row>
                          <Col lg={6} className="mt-2">
                            <label className="title-label">Place</label>
                            <select
                              className="select_form"
                              name={this.fieldNames.place.name}
                              onChange={this.handleInputChange}
                              value={
                                this.state.pageData[
                                  this.fieldNames.place.name
                                ] || ""
                              }
                            >
                              <option value="">Select Place</option>
                              {places &&
                                places.map((item, index) => (
                                  <option
                                    key={item.placeUid}
                                    value={item.placeUid}
                                  >
                                    {item.place}
                                  </option>
                                ))}
                            </select>
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.place.errorKey
                                ]
                              }
                            </div>
                          </Col>
                          <Col lg={6} className="mt-2">
                            <label className="title-label">Page Type</label>
                            <select
                              className="select_form"
                              name={this.fieldNames.pageType.name}
                              onChange={this.handleInputChange}
                              value={
                                this.state.pageData[
                                  this.fieldNames.pageType.name
                                ] || ""
                              }
                            >
                              <option value="">Select Page Type</option>
                              {pageTypes &&
                                pageTypes.map((item, index) => (
                                  <option
                                    key={item.pagetypeUid}
                                    value={item.pagetypeUid}
                                  >
                                    {item.pageType}
                                  </option>
                                ))}
                            </select>
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.pageType.errorKey
                                ]
                              }
                            </div>
                          </Col>
                          <Col lg={6} className="mt-2">
                            <label className="title-label">Title</label>
                            <input
                              type="text"
                              name={this.fieldNames.title.name}
                              className="form-control"
                              placeholder="Enter title"
                              onChange={this.handleInputChange}
                              value={
                                this.state.pageData[
                                  this.fieldNames.title.name
                                ] || ""
                              }
                            />
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.title.errorKey
                                ]
                              }
                            </div>
                          </Col>
                          <Col lg={6} className="mt-2">
                            <label className="title-label">Slug</label>
                            <input
                              type="text"
                              readOnly
                              name="slug"
                              className="form-control"
                              placeholder="Enter Slug"
                              value={this.state.pageData.slug || ""}
                            />
                            <div className="errorMsg">
                              {this.state.errors["slug"]}
                            </div>
                          </Col>
                          <Col lg={6} className="mt-2">
                            <label className="typecheck">
                              Navigation (add tabs to place)
                              <input
                                type="checkbox"
                                name={this.fieldNames.navigation.name}
                                onChange={this.handleInputChange}
                                checked={
                                  this.state.pageData[
                                    this.fieldNames.navigation.name
                                  ]
                                }
                              />
                              <span className="typemark" />
                            </label>
                          </Col>
                          <Col lg={3} className="mt-2">
                            <label className="typecheck">
                              Landing page
                              <input
                                type="checkbox"
                                name={this.fieldNames.landingPage.name}
                                onChange={this.handleInputChange}
                                checked={
                                  this.state.pageData[
                                    [this.fieldNames.landingPage.name]
                                  ]
                                }
                              />
                              <span className="typemark" />
                            </label>
                          </Col>
                          <Col lg={3} className="mt-2">
                            <label className="typecheck">
                              Is deleted
                              <input
                                type="checkbox"
                                name={this.fieldNames.isDeleted.name}
                                onChange={this.handleInputChange}
                                checked={
                                  this.state.pageData[
                                    this.fieldNames.isDeleted.name
                                  ]
                                }
                              />
                              <span className="typemark" />
                            </label>
                          </Col>
                          <Col
                            md={12}
                            className={cx("mt-2", {
                              "d-none": !(
                                this.selectedPageType.pageType === "Static Page"
                              ),
                            })}
                          >
                            <label className="title-label">Content</label>
                            <CKEditor
                              onBeforeLoad={(CKEDITOR) => {
                                if (this.CKE !== null) {
                                  return false;
                                }
                                this.CKE = CKEDITOR;
                                CKEDITOR.disableAutoInline = true;
                                CKEDITOR.addCss(
                                  'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                                );
                                CKEDITOR.on("dialogDefinition", function (ev) {
                                  // Take the dialog window name and its definition from the event data.
                                  const dialogName = ev.data.name;

                                  // debugger;
                                  if (dialogName === "iframe") {
                                    const dialogDefinition = ev.data.definition;
                                    let fileViewType = "list";
                                    const infoTab = dialogDefinition.getContents(
                                      "info"
                                    );
                                    dialogDefinition.minHeight = 150;

                                    const widthField = infoTab.get("width");
                                    widthField["default"] = "100%";
                                    const dNoneStyle = "display: none";
                                    widthField["style"] = dNoneStyle;
                                    const heightField = infoTab.get("height");
                                    heightField["default"] = "180";
                                    heightField["style"] = dNoneStyle;
                                    const scrollingField = infoTab.get(
                                      "scrolling"
                                    );
                                    scrollingField["default"] = true;
                                    scrollingField["style"] = dNoneStyle;
                                    const frameborderField = infoTab.get(
                                      "frameborder"
                                    );
                                    frameborderField["default"] = 1;
                                    frameborderField["style"] = dNoneStyle;
                                    const urlField = infoTab.get("src");

                                    var dialog = ev.data.definition.dialog;
                                    dialog.on("show", function () {
                                      var txtUrlField = this.getContentElement(
                                        "info",
                                        "src"
                                      );
                                    });
                                    infoTab.remove("fileView");
                                    infoTab.remove("align");
                                    // infoTab.remove('scrolling');
                                    // infoTab.remove('frameborder');
                                    infoTab.remove("name");
                                    infoTab.remove("title");
                                    infoTab.remove("longdesc");
                                    infoTab.add({
                                      type: "hbox",
                                      widths: ["50%", "50%"],
                                      children: [
                                        {
                                          type: "radio",
                                          id: "fileView",
                                          label: "Preferred file view",
                                          items: [
                                            ["List View", "list"],
                                            ["Grid View", "grid"],
                                          ],
                                          setup: function () {
                                            const url = this.getDialog().getValueOf(
                                              "info",
                                              "src"
                                            );
                                            if (url.includes("#grid")) {
                                              this.setValue("grid");
                                            }
                                          },
                                          onChange: function () {
                                            var dialog = this.getDialog();
                                            this.iframeFileView = dialog.getValueOf(
                                              "info",
                                              "fileView"
                                            );
                                          },
                                          default: fileViewType,
                                        },
                                      ],
                                    });
                                    dialog.on("ok", function () {
                                      let url = this.getContentElement(
                                        "info",
                                        "src"
                                      ).getValue();
                                      let fileView = this.getContentElement(
                                        "info",
                                        "fileView"
                                      ).getValue();

                                      if (
                                        !url.includes("#grid") &&
                                        !url.includes("#list")
                                      ) {
                                        this.getContentElement(
                                          "info",
                                          "src"
                                        ).setValue(url + "#" + fileView);
                                      }
                                      if (
                                        fileView === "list" &&
                                        url.includes("#grid")
                                      ) {
                                        this.getContentElement(
                                          "info",
                                          "src"
                                        ).setValue(
                                          url.replace("#grid", "#list")
                                        );
                                      }
                                      if (
                                        fileView === "grid" &&
                                        url.includes("#list")
                                      ) {
                                        this.getContentElement(
                                          "info",
                                          "src"
                                        ).setValue(
                                          url.replace("#list", "#grid")
                                        );
                                      }
                                    });
                                  }
                                });
                              }}
                              config={{
                                versionCheck: false,
                                stylesSet: [
                                  // Block-level styles.
                                  {
                                    name: "Content title",
                                    element: "h1",
                                    styles: {
                                      color: "#C41425",
                                      "font-family": "Open Sans Semibold",
                                      "line-height": "135%",
                                    },
                                  },
                                  {
                                    name: "Content Info",
                                    element: "p",
                                    styles: {
                                      color: "#586667",
                                      padding: "0px !important",
                                      "font-family": "Open Sans Light",
                                      "font-size": "14px",
                                    },
                                  },
                                  // Inline styles.
                                  {
                                    name: "Text Gray",
                                    element: "p",
                                    styles: {
                                      color: "#AAA !important",
                                      "font-family": "Open Sans Light",
                                      "font-size": "16px",
                                    },
                                  },
                                  {
                                    name: "Anchor Red",
                                    element: "a",
                                    styles: {
                                      color: "#C41425 !important",
                                      "text-decoration": "none",
                                    },
                                  },
                                ],
                                format_tags:
                                  "p;h1;h2;h3;h4;h5;h6;pre;address;div",
                                extraPlugins: "embed,autoembed,iframe",

                                filebrowserUploadUrl:
                                  config.api_url +
                                  config.url.upload_editor_image,
                                embed_provider:
                                  "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
                              }}
                              onFileUploadRequest={this.onFileUploadReq}
                              onFileUploadResponse={this.onFileUploadRes}
                              onChange={this.onEditorChange}
                              data={
                                this.state.pageData[
                                  this.fieldNames.contentHtml.name
                                ] || ""
                              }
                            />
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.contentHtml.errorKey
                                ]
                              }
                            </div>
                          </Col>
                          <Col
                            md={12}
                            className={cx("mt-2", {
                              "d-none": !(
                                this.selectedPageType.pageType ===
                                this.fileRepoPageTypeName
                              ),
                            })}
                          >
                            <label className="title-label">
                              Google Drive Url
                            </label>
                            <input
                              type="text"
                              name={this.fieldNames.googleFolderID.name}
                              className="form-control"
                              placeholder="Enter Google Drive Url"
                              onChange={this.handleInputChange}
                              value={
                                this.state.pageData[
                                  this.fieldNames.googleFolderID.name
                                ] || ""
                              }
                            />
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.googleFolderID.errorKey
                                ]
                              }
                            </div>
                          </Col>
                          <Col
                            md={12}
                            className={cx("mt-2", {
                              "d-none": !(
                                this.selectedPageType.pageType ===
                                this.fileRepoPageTypeName
                              ),
                            })}
                          >
                            <label className="title-label mb-3">
                              Preferred file view
                            </label>
                            <div className="d-flex">
                              <label className="typeradio mr-4">
                                List
                                <input
                                  type="radio"
                                  name={this.fieldNames.googleFolderID.type}
                                  onChange={this.handleInputChange}
                                  checked={
                                    this.state.pageData[
                                      this.fieldNames.googleFolderID.type
                                    ] === "list"
                                  }
                                  value="list"
                                />
                                <span className="radiomark" />
                              </label>
                              <label className="typeradio">
                                Grid
                                <input
                                  type="radio"
                                  name={this.fieldNames.googleFolderID.type}
                                  onChange={this.handleInputChange}
                                  checked={
                                    this.state.pageData[
                                      this.fieldNames.googleFolderID.type
                                    ] === "grid"
                                  }
                                  value="grid"
                                />
                                <span className="radiomark" />
                              </label>
                              <div className="errorMsg">
                                {
                                  this.state.errors[
                                    this.fieldNames.googleFolderID.errorKey
                                  ]
                                }
                              </div>
                            </div>
                          </Col>
                          <Col md={12} className="mt-2">
                            <label className="title-label">Description</label>
                            <textarea
                              name={this.fieldNames.description.name}
                              rows="8"
                              onChange={this.handleInputChange}
                              value={
                                this.state.pageData[
                                  this.fieldNames.description.name
                                ] || ""
                              }
                            />
                            <div className="errorMsg">
                              {
                                this.state.errors[
                                  this.fieldNames.description.errorKey
                                ]
                              }
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="d-flex justify-content-end pt-3">
                        <button
                          disabled={this.state.isLoading}
                          className="bg-primary filter-btn"
                          onClick={this.onSubmit.bind(this)}
                        >
                          {this.state.isSaving ? "save ..." : "save"}
                        </button>
                        <NavLink to="/admin/">
                          <button className="bg-dark filter-btn">cancel</button>
                        </NavLink>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  // console.log("mapStateToProps state", state);
  const id = props.match.params.id;
  return {
    pageActionLoading: state.pages.actionsloading,
    pageTypes: Object.values(state.pagetypes.byId),
    token: state.user.cognito_data.token,
    user: state.user.user,
    places: Object.values(state.places.byId),
    page: id ? state.pages.byId[id] : "",
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(pagesActions, dispatch)
)(AddPage);
